import React from "react";
import { Route, Switch, Link } from "react-router-dom";
import { BreadcrumbItem } from "reactstrap";
import * as Section from "@repoflow/components/section";
import OrganizationUsersPublicSchema from "@common/schema/organization-users/public";
import KeysPublicSchema from "@common/schema/keys/public";
import * as OrganizationRoute from "./organization";
import * as ListRoute from "./list";
import * as NewRoute from "./new";

const LocalProvider = ({ match: { params, params:{orgId} }, children: Children }) => {
  const parent = Section.useSectionContext();
  const { base: parentBase, basepath: parentBasepath, schema } = parent;
  const base = `${parentBase}/organization`;
  const basepath = `${parentBasepath}/organization`;

  return (
    <Section.Provider
      schema={[...schema,...OrganizationUsersPublicSchema, ...KeysPublicSchema]}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, parent })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:orgId`} component={OrganizationRoute.Content} />
          {/* Last: these paths are prefix matches, there is no `exact`. */}
          <Route path={`${basepath}`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>Organizations</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/new`} component={NewRoute.Indice} />
            <Route path={`${basepath}/:orgId`} component={OrganizationRoute.Indice} />
            <Route path={`${basepath}`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
